<div class="modal-body edit-notes">
  <div class="content">
      <div class="content__top">
          <h4 translate>company.overview.notes.modal.form.{{noteType}}</h4>
          <button type="button" class="close" aria-label="Close" (click)="close()">
              <i class="icon-small-close"></i>
          </button>
      </div>
      <div class="content__form">
        <form [formGroup]="notesForm">
          <div class="form-group">
            <pre class="vox-input-group vox-input-group_dense" >
              <textarea name="notesValue" id="notesValue"
              cols="30" rows="30"
              [readonly]="action === 'view'"
              [placeholder]="'company.overview.notes.modal.form.placeholder' | translate"
              formControlName="notesValue"></textarea>
            </pre>
          </div>
          <div *ngIf="action === 'edit'" class="submit-container">
            <div class="vox-btn vox-btn-primary"
            (click)="onUpdateNotes()"
            [ladda]="loading"
            data-spinner-color="white"
            data-style="zoom-in">
              <span translate>company.overview.notes.modal.form.submit</span>
            </div>
          </div>
        </form>
      </div>
  </div>
</div>
